import { FlexBox, ModalBody, ModalFoot, Spinner } from '@dixa/lib-shared-habla';

type Props = {
  hide: () => void;
};

export function Loading({ hide }: Props): JSX.Element {
  return (
    <>
      <ModalBody>
        <FlexBox flex="1" justifyContent="center" alignItems="center">
          <Spinner />
        </FlexBox>
      </ModalBody>

      <ModalFoot cancelOnClick={hide} />
    </>
  );
}
